import * as IoC from 'typescript-ioc';
import { IApiClient } from './infrastructure/api-client';
import { ApiClient } from './infrastructure/implementations/api-client';
import { ApiClientRetryHandleDecorator } from './infrastructure/implementations/api-client-retryable-decorator';
import { AbstractFormViewModelController } from './infrastructure/implementations/form-viewmodel-controller';
import { RuntimeConfiguration } from './infrastructure/implementations/runtime-configuration';
import { IRouter } from './infrastructure/router';
import { Router } from './infrastructure/implementations/router';
import { IRuntimeConfiguration } from './infrastructure/runtime-configuration';
import { ICookiesService } from './infrastructure/cookies';
import { ILocalStorageService } from './infrastructure/local-storage-service';
import { CookiesService } from './infrastructure/implementations/cookies';
import { LocalStorageService } from './infrastructure/implementations/local-storage-service';
import { AuthAggregateProvider } from './domain/auth/implementations/auth-aggregate-provider';
import { APIClientAuthDecorator } from './domain/auth/implementations/api-client-auth-decorator';
import { EventsDAO } from './api/implementations/events.dao';
import { IEventsDAO } from './api/events.dao';
import { ISalesforceOrderDAO } from './api/salesforce-order.dao';
import { SalesforceOrderDAO } from './api/implementations/salesforce-order.dao';
import { IEventLinksDAO } from './api/event-links.dao';
import { EventLinksDAO } from './api/implementations/event-links.dao';
import { IWebsiteDAO } from './api/website.dao';
import { IMeetingsDAO } from './api/meetings.dao';
import { ITimeZonesDAO } from './api/timezones.dao';
import { MeetingsDAO } from './api/implementations/meetings.dao';
import { IAttendeesDAO } from './api/attendees.dao';
import { AttendeesDAO } from './api/implementations/attendees.dao';
import { IRolodexDAO } from './api/rolodex.dao';
import { RolodexDAO } from './api/implementations/rolodex.dao';
import { IOrganizationsDAO } from './api/organizations.dao';
import { OrganizationsDAO } from './api/implementations/organizations.dao';
import { TimeZonesDAO } from './api/implementations/timezones.dao';
import { IZoomDAO } from './api/zoom.dao';
import { ZoomDAO } from './api/implementations/zoom.dao';
import { IErrorParsing } from './infrastructure/error-parsing';
import { ErrorParsing } from './infrastructure/implementations/error-parsing';
import { AccountsDAO } from './api/implementations/accounts.dao';
import { IAccountsDAO } from './api/accounts.dao';
import { TrackedUsersViewModel } from './components/_zoom/_tracked-users-list/tracked-users.viewmodel';
import { ZoomUsersManagementViewModel } from './components/_zoom/_zoom-users-management/zoom-users-management.viewmodel';
import { ZoomViewModel } from './components/_zoom/zoom.viewmodel';
import { IApiDateConverter } from './infrastructure/api-date-converter';
import { ApiDateConverter } from './infrastructure/implementations/api-date-converter';
import { ITableSort } from './infrastructure/utils/table-sorting.service';
import { TableSort } from './infrastructure/utils/implementation/table-sorting.service';
import { IDateTimeFormatter } from './infrastructure/date-formatter';
import { DateTimeFormatter } from './infrastructure/implementations/date-formatter';
import { IAlertsService } from './infrastructure/alerts';
import { AlertsService } from './infrastructure/implementations/alerts';
import { ISubWindowsService } from './infrastructure/sub-windows';
import { SubWindowsService } from './infrastructure/implementations/sub-window';
import { IRoomsDAO } from './api/rooms.dao';
import { RoomsDAO } from './api/implementations/rooms.dao';
import { IConnectionsDAO } from './api/connections.dao';
import { ConnectionsDAO } from './api/implementations/connections.dao';
import { WebsiteDAO } from './api/implementations/website.dao';
import { IJobsDAO } from './api/jobs.dao';
import { JobsDAO } from './api/implementations/jobs.dao';
import { IJobsMonitor } from './domain/jobs-monitor/jobs-monitor';
import { JobsMonitor } from './domain/jobs-monitor/implementations/jobs-monitor';
import { IControlDAO } from './api/control.dao';
import { ControlDAO } from './api/implementations/control.dao';
import { IOperatorsDAO } from './api/operators.dao';
import { IUsersDAO } from './api/users.dao';
import { IThemesDAO } from './api/themes.dao';
import { IRolesDAO } from './api/roles.dao';
import { IUserGroupsDAO } from './api/user-groups.dao';
import { UserGroupsDAO } from './api/implementations/user-groups.dao';
import { OperatorsDAO } from './api/implementations/operators.dao';
import { UsersDAO } from './api/implementations/users.dao';
import { RolesDAO } from './api/implementations/roles.dao';
import { ThemesDAO } from './api/implementations/themes.dao';
import { ICustomPagesDAO } from './api/custom-pages.dao';
import { CustomPagesDAO } from './api/implementations/custom-pages.dao';
import { IModalService } from './infrastructure/modal';
import { ModalService } from './infrastructure/implementations/modal';
import { ConnectionVmProvider } from './modules/connections/event-connection-vm.provider';
import { IEmailConfigurationDAO } from './api/email-configuration.dao';
import { EmailConfigurationDAO } from './api/implementations/email-configuration.dao';
import { IBlueprintEmailConfigurationDAO } from './api/blueprint-email-configuration.dao';
import { BlueprintEmailConfigurationDAO } from './api/implementations/blueprint-email-configuration.dao';
import { ExecutionRuntime } from './domain/jobs/execution-runtime';
import { EventExecutionRuntime } from './domain/jobs/implementations/event-execution-runtime';
import { IPassportSettingsConfigurationDAO } from './api/passport-settings-configuration.dao';
import { PassportSettingsConfigurationDAO } from './api/implementations/passport-settings-configuration.dao';
import { SignInConfigurationDAO } from './api/implementations/sign-in-configuration.dao';
import { ISignInConfigurationDAO } from './api/sign-in-configuration.dao';
import { FileToS3DAO } from './api/implementations/file-to-s3.dao';
import { IFileToS3DAO } from './api/file-to-s3.dao';
import { IAccountGroupsDAO } from './api/account-groups.dao';
import { AccountGroupsDAO } from './api/implementations/account-groups.dao';
import { IReportsDAO } from './api/reports.dao';
import { ReportsDAO } from './api/implementations/reports.dao';
import { ICustomCssDAO } from './api/custom-css.dao';
import { CustomCssDAO } from './api/implementations/custom-css.dao';
import { IPassportUrlRedirectionDAO } from './api/passport-url-redirection.dao';
import { PassportUrlRedirectionDAO } from './api/implementations/passport-url-redirection.dao';
import TrackingServiceProvider from './tracking-service/tracking-service-provider';
import { JobTrackingService } from './domain/jobs/implementations/job-tracking.service';
import { IAccountAdminDAO } from './api/account-admin';
import { AccountAdminDAO } from './api/implementations/account-admin.dao';
import { IAccountUsersDAO } from './api/account-users.dao';
import { AccountUsersDAO } from './api/implementations/account-users.dao';
import { IScheduledEmailDAO } from './api/scheduled-email.dao';
import { ScheduledEmailDAO } from './api/implementations/scheduled-email.dao';
import { AppConfigurationDAO } from './api/implementations/app-configuration.dao';
import { IAppConfigurationDAO } from './api/app-configuration.dao';
import { AuthServiceConfigurator } from './domain/auth/implementations/auth-service-configurator';
import { IGlobalStorage } from './infrastructure/global-storage';
import { GlobalStorage } from './infrastructure/implementations/global-storage';
import { AssetsDAO } from './api/implementations/assets.dao';
import { IAssetsDAO } from './api/assets.dao';
import { ArtifactsDAO } from './api/implementations/artifacts.dao';
import { IArtifactsDAO } from './api/artifacts.dao';
import { IBlueprintsDAO } from './api/blueprints/blueprints.dao';
import { BlueprintsDAO } from './api/implementations/blueprints.dao';
import { IKnovioPreviewLinkDAO } from './api/knovio-preview-link.dao';
import { KnovioPreviewLinkDAO } from './api/implementations/knovio-preview-link.dao';
import { GlobalViewModel } from './components/global.viewmodel';
import { ReactIntlServiceProvider } from './infrastructure/implementations/react-intl-provider';
import { IReactIntlProvider } from './infrastructure/react-intl-provider';
import { IEmailTemplatesDAO } from './api/email-templates.dao';
import { EmailTemplatesDAO } from './api/implementations/email-templates.dao';
import { IEventDispatcher } from './infrastructure/event-dispatcher';
import { EventDispatcherService } from './infrastructure/implementations/event-dispatcher';
import { IAudioBridgeDAO } from './api/audio-bridge.dao';
import { AudioBridgeDAO } from './api/implementations/audio-bridge.dao';
import { IAIFeatureDAO } from './api/ai-feature.dao';
import { AIFeatureDAO } from './api/implementations/ai-feature.dao';
import { IPodiumDAO } from './api/podium.dao';
import { PodiumDAO } from './api/implementations/podium.dao';
import { IMeetingLinksDAO } from './api/meeting-links.dao';
import { MeetingLinksDAO } from './api/implementations/meeting-links.dao';
import { IEventHubsDAO } from './api/event-hubs.dao';
import { EventHubsDAO } from './api/implementations/event-hubs.dao';
import { IAccountOrganizationsDAO } from './api/account-organizations.dao';
import { AccountOrganizationsDAO } from './api/implementations/account-organizations.dao';
import { IAccountContactsDAO } from './api/account-contacts.dao';
import { AccountContactsDAO } from './api/implementations/account-contacts.dao';
import { IHubRegistrationConfigurationDAO } from './api/hub-registration-configuration.dao';
import { HubRegistrationConfigurationDAO } from './api/implementations/hub-registration-configuration.dao';
import { IPassportAttendeeSSODAO } from './api/passport-attendee-sso.dao';
import { PassportAttendeeSSODAO } from './api/implementations/passport-attendee-sso.dao';
import { IAttributesDAO } from './api/attributes.dao';
import { AttributesDAO } from './api/implementations/attributes.dao';
import { IOeDataOrganizationsDAO } from './api/oe-data-organizations.dao';
import { OeDataOrganizationsDAO } from './api/implementations/oe-data-organizations.dao';

IoC.Container.bind(IApiClient).factory(context => {
    return new ApiClientRetryHandleDecorator(
        new APIClientAuthDecorator(
            new ApiClient(context.resolve(IRuntimeConfiguration)),
            context.resolve(AuthAggregateProvider),
        )
    );
}).scope(IoC.Scope.Singleton);

IoC.Container.bind(GlobalViewModel).scope(IoC.Scope.Singleton);

IoC.Container.bind(IEventsDAO).to(EventsDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(ISalesforceOrderDAO).to(SalesforceOrderDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IEventLinksDAO).to(EventLinksDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IRoomsDAO).to(RoomsDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IMeetingsDAO).to(MeetingsDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IAttendeesDAO).to(AttendeesDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IRolodexDAO).to(RolodexDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IOrganizationsDAO).to(OrganizationsDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(ITimeZonesDAO).to(TimeZonesDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IZoomDAO).to(ZoomDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IAccountsDAO).to(AccountsDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IAccountGroupsDAO).to(AccountGroupsDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IWebsiteDAO).to(WebsiteDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IRoomsDAO).to(RoomsDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IConnectionsDAO).to(ConnectionsDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IJobsDAO).to(JobsDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IControlDAO).to(ControlDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IOperatorsDAO).to(OperatorsDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IUsersDAO).to(UsersDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IRolesDAO).to(RolesDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IUserGroupsDAO).to(UserGroupsDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IThemesDAO).to(ThemesDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IReportsDAO).to(ReportsDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IEmailConfigurationDAO).to(EmailConfigurationDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IBlueprintEmailConfigurationDAO).to(BlueprintEmailConfigurationDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(ICustomCssDAO).to(CustomCssDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IPassportUrlRedirectionDAO).to(PassportUrlRedirectionDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(ICustomPagesDAO).to(CustomPagesDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(ISignInConfigurationDAO).to(SignInConfigurationDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IPassportSettingsConfigurationDAO).to(PassportSettingsConfigurationDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IFileToS3DAO).to(FileToS3DAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IAccountAdminDAO).to(AccountAdminDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IAccountUsersDAO).to(AccountUsersDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IScheduledEmailDAO).to(ScheduledEmailDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IAppConfigurationDAO).to(AppConfigurationDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IAssetsDAO).to(AssetsDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IArtifactsDAO).to(ArtifactsDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IBlueprintsDAO).to(BlueprintsDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IEmailTemplatesDAO).to(EmailTemplatesDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IKnovioPreviewLinkDAO).to(KnovioPreviewLinkDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IAudioBridgeDAO).to(AudioBridgeDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IAIFeatureDAO).to(AIFeatureDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IPodiumDAO).to(PodiumDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IMeetingLinksDAO).to(MeetingLinksDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IEventHubsDAO).to(EventHubsDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IAccountOrganizationsDAO).to(AccountOrganizationsDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IAccountContactsDAO).to(AccountContactsDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IHubRegistrationConfigurationDAO).to(HubRegistrationConfigurationDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IPassportAttendeeSSODAO).to(PassportAttendeeSSODAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IAttributesDAO).to(AttributesDAO).scope(IoC.Scope.Singleton);
IoC.Container.bind(IOeDataOrganizationsDAO).to(OeDataOrganizationsDAO).scope(IoC.Scope.Singleton);

IoC.Container.bind(IErrorParsing).to(ErrorParsing).scope(IoC.Scope.Singleton);
IoC.Container.bind(IRouter).to(Router).scope(IoC.Scope.Singleton);
IoC.Container.bind(IRuntimeConfiguration).to(RuntimeConfiguration).scope(IoC.Scope.Singleton);
IoC.Container.bind(ICookiesService).to(CookiesService).scope(IoC.Scope.Singleton);
IoC.Container.bind(ILocalStorageService).to(LocalStorageService).scope(IoC.Scope.Singleton);
IoC.Container.bind(AuthAggregateProvider).to(AuthAggregateProvider).scope(IoC.Scope.Singleton);
IoC.Container.bind(ITableSort).to(TableSort).scope(IoC.Scope.Singleton);
IoC.Container.bind(IAlertsService).to(AlertsService).scope(IoC.Scope.Singleton);
IoC.Container.bind(ISubWindowsService).to(SubWindowsService).scope(IoC.Scope.Singleton);
IoC.Container.bind(IApiDateConverter).to(ApiDateConverter).scope(IoC.Scope.Singleton);
IoC.Container.bind(IDateTimeFormatter).to(DateTimeFormatter).scope(IoC.Scope.Singleton);
IoC.Container.bind(IJobsMonitor).to(JobsMonitor).scope(IoC.Scope.Singleton);
IoC.Container.bind(IModalService).to(ModalService).scope(IoC.Scope.Singleton);
IoC.Container.bind(ExecutionRuntime).to(EventExecutionRuntime).scope(IoC.Scope.Singleton);
IoC.Container.bind(TrackingServiceProvider).to(TrackingServiceProvider).scope(IoC.Scope.Singleton);
IoC.Container.bind(JobTrackingService).to(JobTrackingService).scope(IoC.Scope.Singleton);
IoC.Container.bind(AuthServiceConfigurator).to(AuthServiceConfigurator).scope(IoC.Scope.Singleton);
IoC.Container.bind(IGlobalStorage).to(GlobalStorage).scope(IoC.Scope.Singleton);
IoC.Container.bind(IReactIntlProvider).to(ReactIntlServiceProvider).scope(IoC.Scope.Singleton);
IoC.Container.bind(IEventDispatcher).to(EventDispatcherService).scope(IoC.Scope.Singleton);

// ViewModels per particular feature
IoC.Container.bind(ZoomViewModel).to(ZoomViewModel).scope(IoC.Scope.Singleton);
IoC.Container.bind(TrackedUsersViewModel).to(TrackedUsersViewModel).scope(IoC.Scope.Request);
IoC.Container.bind(ZoomUsersManagementViewModel).to(ZoomUsersManagementViewModel).scope(IoC.Scope.Request);
IoC.Container.bind(ConnectionVmProvider).to(AbstractFormViewModelController).scope(IoC.Scope.Request);
